import React from 'react';

/**
 * TypingIndicator
 * ---------------
 * Simple three-dot pulse animation shown while the bot is thinking.
 */

const STYLES = `
  @keyframes ti-dot-blink { 0%,80%,100%{opacity:.2} 40%{opacity:1} }
`;

const TypingIndicator = () => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '4px 2px' }}>
        <style>{STYLES}</style>
        {[0, 0.2, 0.4].map((d, i) => (
            <span key={i} style={{
                width: 7, height: 7, borderRadius: '50%', background: '#9ca3af', display: 'inline-block',
                animation: `ti-dot-blink 1s ${d}s infinite ease-in-out`,
            }} />
        ))}
    </div>
);

export default TypingIndicator;
